import { AppUser } from '@/types';
import { getClientAuthHeaders } from './clientAuthHeaders';

export interface UpdateProfileResult {
  success: boolean;
  user?: AppUser;
  error?: string;
}

/**
 * Actualiza los campos de perfil del usuario en la base de datos Firestore
 * (ciudades, zonas, rango de precios, zoho id, onboardingCompleted, etc.)
 */
export async function updateUserProfileApi(
  userId: string,
  data: Partial<AppUser> | Record<string, any>
): Promise<UpdateProfileResult> {
  if (!userId || userId === 'guest-client') {
    return { success: false, error: 'Usuario no autenticado o ID inválido' };
  }

  try {
    const headers = await getClientAuthHeaders();
    const res = await fetch('/api/auth/profile', {
      method: 'PATCH',
      headers,
      body: JSON.stringify({ userId, ...data }),
    });

    const result = await res.json();
    if (!res.ok || !result.success) {
      return {
        success: false,
        error: result.error || 'Error al persistir los datos de perfil en el servidor.',
      };
    }

    return {
      success: true,
      user: result.user,
    };
  } catch (err: any) {
    return {
      success: false,
      error: err?.message || 'Error de conexión al actualizar el perfil.',
    };
  }
}
